import { ConfiguratorId, ConfiguratorPriceTable, ConfiguratorPriceTableItem } from "#models/Configurator"
import * as Struct from "effect/Struct"
import { S, TaggedRequestFor } from "../../lib.ts"
import { ConfiguratorOptionEntryView, ConfiguratorPriceTableEntryView } from "./Views.ts"

// codegen:start {preset: meta, sourcePrefix: src/resources/ }
const Req = TaggedRequestFor("Admin/Configurator/PriceTable")
// codegen:end

export class AllConfiguratorPriceTablesResponse extends S.Opaque<AllConfiguratorPriceTablesResponse>()(
  S
    .Struct({
      priceTables: S.Array(ConfiguratorPriceTableEntryView)
    })
    .annotate({ identifier: "AllConfiguratorPriceTablesResponse" })
) {}
export class AllConfiguratorPriceTables extends Req.Query<AllConfiguratorPriceTables>()("AllConfiguratorPriceTables", {
  id: ConfiguratorId
}, { success: AllConfiguratorPriceTablesResponse }) {}

export const ConfiguratorPriceTableItemInput = ConfiguratorPriceTableItem.mapFields(Struct.omit(["timestamps"]))

export class ConfiguratorPriceTableInput
  extends S.Opaque<ConfiguratorPriceTableInput, ConfiguratorPriceTableInput.Encoded>()(
    S
      .Struct({
        ...Struct.omit(ConfiguratorPriceTable.fields, ["timestamps", "id", "items"]),
        items: S.Array(ConfiguratorPriceTableItemInput)
      })
      .annotate({ identifier: "ConfiguratorPriceTableInput" })
  )
{}

export class CreateConfiguratorPriceTableResponse extends S.Opaque<CreateConfiguratorPriceTableResponse>()(
  S
    .Struct({
      id: S.StringId
    })
    .annotate({ identifier: "CreateConfiguratorPriceTableResponse" })
) {}

export class CreateConfiguratorPriceTable
  extends Req.Command<CreateConfiguratorPriceTable>()("CreateConfiguratorPriceTable", {
    configuratorId: ConfiguratorId,
    name: S.NonEmptyString255
  }, { success: CreateConfiguratorPriceTableResponse })
{}

export class GetConfiguratorPriceTableResponse extends S.Opaque<GetConfiguratorPriceTableResponse>()(
  S
    .Struct({
      priceTable: ConfiguratorPriceTable,
      options: S.Array(ConfiguratorOptionEntryView),
      hasCHF: S.Boolean
    })
    .annotate({ identifier: "GetConfiguratorPriceTableResponse" })
) {}

export class GetConfiguratorPriceTable extends Req.Query<GetConfiguratorPriceTable>()("GetConfiguratorPriceTable", {
  id: S.StringId,
  configuratorId: ConfiguratorId
}, { success: GetConfiguratorPriceTableResponse }) {}

export class RemoveConfiguratorPriceTable
  extends Req.Command<RemoveConfiguratorPriceTable>()("RemoveConfiguratorPriceTable", {
    configuratorId: ConfiguratorId,
    id: S.StringId
  })
{}

export class SortConfiguratorPriceTable
  extends Req.Command<SortConfiguratorPriceTable>()("SortConfiguratorPriceTable", {
    configuratorId: ConfiguratorId,
    order: S.Array(S.StringId)
  })
{}

export class UpdateConfiguratorPriceTable
  extends Req.Command<UpdateConfiguratorPriceTable>()("UpdateConfiguratorPriceTable", {
    configuratorId: ConfiguratorId,
    id: S.StringId,
    priceTable: ConfiguratorPriceTableInput
  })
{}

// codegen:start {preset: model}
//
export namespace ConfiguratorPriceTableInput {
  export interface Encoded extends S.StructNestedEncoded<typeof ConfiguratorPriceTableInput> {}
}
//
// codegen:end
